export const maskCredentialsInUrl = (url: URL, mask = "*****") => {
  if (url.username) url.username = mask;
  if (url.password) url.password = mask;
  return url.toString();
};
